export default __webpack_public_path__ + "static/media/Tomisin3.c870cf57.jpg";